import {classNames} from "../../helpers";

const RadioInput = (props) => {
  const { label, name, value, subLabel, items, onChange, inline } = props;

  return (
    <fieldset className="mb-4">
      <legend className="contents text-base font-medium text-gray-700">{label}</legend>
      <p className="text-sm text-gray-500">{subLabel}</p>
      <div className={classNames('mt-4', inline ? 'flex items-center' : 'space-y-4')}>
        {items.map(item => (
          <div key={item.id} className={classNames('flex items-center', inline ? 'mr-10' : '')}>
            <input
              id={item.id}
              name={name}
              type="radio"
              value={item.value}
              checked={value === item.value}
              className={classNames(
                'focus:ring-artfulRed-550 h-4 w-4 text-artfulRed border-gray-300 hover:border-artfulRed-550',
                'transition-all duration-300 ease-in-out'
              )}
              onChange={onChange}
            />
            <label
              htmlFor={item.id}
              className="ml-3 block text-sm font-medium text-gray-700">
              {item.text}
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  )
};

RadioInput.defaultProps = {
  items: [],
  inline: false,
};

export default RadioInput;
